import { Link } from '@remix-run/react'

import {
    Flex,
    Container,
    Stack,
    Heading,
    Text,
    useColorModeValue,
    useMediaQuery,
    Button
} from '@chakra-ui/react'

import theme from '../../../Config/theme'

import { FaQuestion, FaEnvelope } from "react-icons/fa";

const ContactInformation = () => {
    const backgroundColor = useColorModeValue('gray.100', 'gray.800')

    const isDesktop = useMediaQuery("(min-width: 768px)")

    const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)

    return (
        <Flex
            w={'full'}
            h={'40vg'}
            pt={5}
            pb={'10vh'}
        >
            <Container
                maxW={'4xl'}
            >
                <Stack direction={'column'} spacing={10}>

                    <Stack
                        direction={{ base: 'column', md: 'row' }}
                        align={'center'}
                        spacing={10}
                        borderRadius={'md'}
                        bgColor={backgroundColor}
                        p={5}
                        border={'1px'}
                        borderColor={borderColor}
                        style={{ transition: 'transform .2s' }}
                        _hover={{ transform: 'scale(1.03)', boxShadow: `5px 5px ${theme.default.defaultColor}` }}
                    >
                        <FaQuestion size={40} />
                        <Stack direction={'column'} textAlign={{ base: 'center', md: 'start' }}>
                            <Heading fontSize={'2xl'}>Support Center</Heading>
                            <Text fontSize={'lg'}>Have questions? We're here to help. Get quick answers with our FAQs.</Text>
                        </Stack>
                        <Link to={'/faq'}>
                            <Button
                                _hover={{}}
                                _active={{}}
                                _focus={{}}
                                bgColor={theme.default.defaultColor}
                                borderRadius={'full'}
                                size={'lg'}
                                width={!isDesktop[0] && 'full'}
                                color={'white'}
                            >
                                Find Answers
                            </Button>
                        </Link>
                    </Stack>

                    <Stack
                        direction={{ base: 'column', md: 'row' }}
                        align={'center'}
                        spacing={10}
                        borderRadius={'md'}
                        bgColor={backgroundColor}
                        p={5}
                        border={'1px'}
                        borderColor={borderColor}
                        style={{ transition: 'transform .2s' }}
                        _hover={{ transform: 'scale(1.03)', boxShadow: `5px 5px ${theme.default.defaultColor}` }}
                    >
                        <FaEnvelope size={40} />
                        <Stack direction={'column'} textAlign={{ base: 'center', md: 'start' }}>
                            <Heading fontSize={'2xl'}>Email Us</Heading>
                            <Text fontSize={'lg'}>Didn't find an aswer in our FAQs? Send us an email at contact@daddysteach.com</Text>
                        </Stack>
                        <a href={'mailto:contact@daddysteach.com'}>
                            <Button
                                _hover={{}}
                                _active={{}}
                                _focus={{}}
                                bgColor={theme.default.defaultColor}
                                borderRadius={'full'}
                                size={'lg'}
                                width={!isDesktop[0] && 'full'}
                                color={'white'}
                            >
                                Email Us
                            </Button>
                        </a>
                    </Stack>
                </Stack>
            </Container>
        </Flex>
    )
}

export default ContactInformation